import {  Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import React from 'react'

const useNotificationDialog = () => {

    const [open, setOpen] = React.useState(false)


    const handleOpen=React.useCallback(()=>{
        setOpen(true)
    },[])

    const handleClose=React.useCallback(()=>{
        setOpen(false)
    },[])

    const ShowNotificationDialog = React.useCallback(({title,children, action})=>{

        return (
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {children}
                </DialogContent>
                <DialogActions>
                   {action}
                </DialogActions>
            </Dialog>
        )
      },[handleClose, open])
    
    return { ShowNotificationDialog,  open, handleClose, handleOpen }
}

export default useNotificationDialog
